import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const lorasSlice = createSlice({
  name: "loras",
  initialState: {
	items: [],
    status: "idle",
    error: null,
  },
  reducers: {
    clearLoras: (state) => {
      state.items = [];
    },
    deleteLora: (state, action) => {
      const key = action.payload;
      state.items = state.items.filter((image) => image.key !== key);
    },
    addLora: (state, action) => {
      let character = action.payload;
      // disambiguate system loras ids and characters ids
      character.key = character.id + character.name;
      state.items.push(character);
    },
    updateLora: (state, action) => {
      const { key, strength, description } = action.payload;
      state.items = state.items.map((lora) => {
        if(lora.key === key){
          return {
            ...lora,
            strength: strength === undefined ? lora.strength : strength,
            description: description === undefined ? lora.description : description,
          }
        }
        return lora;
      })
    },
  },
});

export const { addLora, updateLora, deleteLora, clearLoras } = lorasSlice.actions;
export default lorasSlice.reducer;
